import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Header from "../Header/Header";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
// import LocationOnIcon from '@mui/icons-material/LocationOn';
import { styled } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import { fontWeight } from "@mui/system";
import "./LandingPage.css";
import { CardActions } from "@mui/material";
import { LandingPageCards } from "./LandingPageCards/LandingPageCards";
// import TagButton from "./TagButton/TagButton";
import HeroSection from "../HeroSection/HeroSection";
import PersonalAndBusinessCard from "./PersonalAndBusinessCard/PersonalAndBusinessCard";
import DiscountFooterSection from "../DiscountFooterSection/DiscountFooterSection";
import CarSection from "./CarSection/CarSection";
import WorkSection from "./WorkSection/WorkSection";
import Discover from "./DiscoverSec/Discover";
import CustomerComment from "./CustomerComment/CustomerComment";
import WideSelectionSection from "./WideSelectionSection/WideSelectionSection";
import CatererDriverSec from "./CatererDriverSec/CatererDriverSec";
import PhoneApps from "./PhoneAppsSec/PhoneApps";
import Footer from "../Footer/Footer";
import { useState } from "react";
import MainModal from "../MyActivityComponents/Modals/MainModal";
import { useGetDishesCountryViseQuery } from "../../api/menu";
import { useGetMenuCountryViseQuery } from "../../api/menu";

import { useGetUserQuery } from "../../api/profile";

export default function Landingpage1() {
  const [mainModalOpen, setMainModalOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const { data: dishes, isLoading } = useGetDishesCountryViseQuery();
  const {data:menus } = useGetMenuCountryViseQuery();
  // dishes
  console.log( "dishes" , dishes)
  // console.log( "dishes" , dishes.data)
  // console.log( "show menu" , showMenu)
  console.log("menues" , menus)
  

  return (
    <>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <>
          {dishes && dishes.data && <Box
            component="container"
            sx={{
              margin: "0px",
              padding: "0px",
              // border:"1px solid red"
            }}
          >
            <Box>
              <HeroSection handleMainModal={() => setMainModalOpen(true)} />
            </Box>

            <Box
              sx={{
                margin: "20px",
                overflowX: "hidden",
              }}
            >
              <Box mt="80px">
                <Discover
                  onAllMenuClicked={() => {
                    setShowMenu(true);
                  }}
                />
              </Box>

              <Box
                sx={{
                  mt: "50px",
                  // border:"1px solid red"
                }}
              >
                {showMenu ? (
                  <LandingPageCards showMenu={showMenu} dishes={dishes.data} />
                ) : (
                  dishes && <LandingPageCards dishes={dishes.data} />
                )}
                {/* <LandingPageCards dispProp="none"/> */}
              </Box>

              <Box marginTop="96px">
                <CarSection />
              </Box>

              <Box>
                <WorkSection />
              </Box>

              <Box>
                <WideSelectionSection />
              </Box>

              <Box sx={{ mt: "40px" }}>
                <PersonalAndBusinessCard />
              </Box>

              <Box sx={{ margin: "10px" }}>
                <CustomerComment />
              </Box>

              <Box>
                <CatererDriverSec />
              </Box>

              <Box>
                <PhoneApps />
              </Box>

              <Box width="100%">
                {<DiscountFooterSection />}
              </Box>
            </Box>

            <Box
              mt="80px"
              mb="80px"
              sx={{
                textAlign: { sm: "center", xs: "center", md: "center" },
                alignItems: { sm: "center", xs: "center", md: "center" },
                // border:"1px solid greesn"
              }}
            >
              <Footer />
            </Box>
            {mainModalOpen && (
              <MainModal
                handleClose={() => setMainModalOpen(false)}
                handleClickTab={(e) => {
                  console.log("handleClickTab", e);
                }}
              />
            )}
          </Box>}
        </>
      )}
    </>
  );
}
